import React from "react";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { useApp } from "@/contexts/AppContext";
import LangSwitcher from "@/components/LangSwitcher";
import { HeartPulse, LayoutDashboard, Building2, ScrollText, LogOut, Shield, Inbox, UsersRound, DollarSign, Megaphone, Landmark, GraduationCap, CreditCard } from "lucide-react";

export default function SuperAdminLayout() {
  const { t, user, logout } = useApp();
  const navigate = useNavigate();

  const links = [
    { to: "/super-admin", end: true, label: t.super.home, icon: LayoutDashboard, testid: "super-nav-home" },
    { to: "/super-admin/hospitals", label: t.super.hospitals, icon: Building2, testid: "super-nav-hospitals" },
    { to: "/super-admin/staff", label: "Équipes", icon: UsersRound, testid: "super-nav-staff" },
    { to: "/super-admin/campaigns", label: "Campagnes", icon: Megaphone, testid: "super-nav-campaigns" },
    { to: "/super-admin/finance", label: "Finances", icon: DollarSign, testid: "super-nav-finance" },
    { to: "/super-admin/subscriptions", label: "Abonnements", icon: CreditCard, testid: "super-nav-subscriptions" },
    { to: "/super-admin/ministry", label: "Ministère", icon: Landmark, testid: "super-nav-ministry" },
    { to: "/formation", label: "Formation", icon: GraduationCap, testid: "super-nav-formation" },
    { to: "/super-admin/messages", label: "Messages", icon: Inbox, testid: "super-nav-messages" },
    { to: "/super-admin/audit", label: t.super.audit, icon: ScrollText, testid: "super-nav-audit" },
  ];

  return (
    <div className="min-h-screen bg-[#FDFBF7] flex">
      <aside className="w-64 bg-[#1E4631] text-white flex flex-col sticky top-0 h-screen">
        <div className="px-6 py-5 border-b border-white/10 flex items-center gap-2">
          <div className="w-9 h-9 rounded-xl bg-[#D96C4A] grid place-items-center">
            <Shield className="w-5 h-5 text-white"/>
          </div>
          <div>
            <div className="font-[Outfit] font-bold">KWIKILA</div>
            <div className="text-[10px] uppercase tracking-widest text-[#D96C4A]">Super-Admin</div>
          </div>
        </div>
        <nav className="flex-1 px-3 py-4 space-y-1">
          {links.map((l) => (
            <NavLink key={l.to} to={l.to} end={l.end} data-testid={l.testid}
              className={({ isActive }) =>
                `flex items-center gap-3 px-4 py-2.5 rounded-lg text-sm font-medium transition ${
                  isActive ? "bg-white text-[#1E4631]" : "text-white/70 hover:bg-white/10 hover:text-white"
                }`}>
              <l.icon className="w-4 h-4"/> {l.label}
            </NavLink>
          ))}
        </nav>
        <div className="p-4 border-t border-white/10 space-y-3">
          <div className="text-xs">
            <div className="font-semibold truncate">{user?.name}</div>
            <div className="truncate text-white/60">{user?.email}</div>
          </div>
          <button data-testid="super-logout" onClick={() => { logout(); navigate("/login"); }}
            className="w-full inline-flex items-center justify-center gap-2 px-3 py-2 rounded-lg bg-white/5 hover:bg-white/10 text-sm font-medium transition">
            <LogOut className="w-4 h-4"/> {t.dash.logout}
          </button>
        </div>
      </aside>
      <div className="flex-1 flex flex-col">
        <header className="bg-white border-b border-[#E5EBE7] sticky top-0 z-30">
          <div className="px-8 py-4 flex items-center justify-between">
            <div className="flex items-center gap-2 text-sm">
              <HeartPulse className="w-4 h-4 text-[#1E4631]"/>
              <span className="text-[#5C6B61]">Vue globale plateforme · {user?.name}</span>
            </div>
            <LangSwitcher/>
          </div>
        </header>
        <main className="flex-1 p-8 overflow-x-auto"><Outlet/></main>
      </div>
    </div>
  );
}
